import { combineReducers } from "redux";

// Reducers
import auth from "./auth.reducer";
import company from "./company.reducer";
import job from "./job.reducer";
import assessment from "./assessment.reducer";
import candidate from "./candidate.reducer";
import search from "./search.reducer";
import messageReducer from "./message.reducer";
import payment from "./payment.reducer";
import bank from "./bank.reducer";
import subscription from "./subscription.reducer";
import notification from "./notification.reducer";

// Root reducer
const rootReducer = combineReducers({
  auth,
  company,
  job,
  assessment,
  candidate,
  search,
  messageReducer,
  payment,
  bank,
  subscription,
  notification
});

// Type for the entire Redux state
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
